// extracted by mini-css-extract-plugin
export default {"globalAlert":"GlobalAlert_globalAlert__BJEJD"};